import { useEffect } from 'react';

const WIDGET_ID = process.env.REACT_APP_GHL_CHAT_WIDGET_ID;
const GHL_HOST = 'https://widgets.leadconnectorhq.com';

const removeWidget = () => {
  document.querySelectorAll(`chat-widget, script[src^="${GHL_HOST}"]`).forEach((el) => el.remove());
};

export const GhlChatWidget = () => {
  useEffect(() => {
    if (!WIDGET_ID) return undefined;
    const timer = setTimeout(() => {
      if (document.querySelector('chat-widget')) return;
      const s = document.createElement('script');
      s.src = `${GHL_HOST}/loader.js`;
      s.async = true;
      s.setAttribute('data-resources-url', `${GHL_HOST}/chat-widget/loader.js`);
      s.setAttribute('data-widget-id', WIDGET_ID);
      document.body.appendChild(s);
    }, 50);
    return () => {
      clearTimeout(timer);
      removeWidget();
    };
  }, []);
  return null;
};
